<template>
  <div v-if="dkshare">
    <global-header
      :size="size"
      :theme="headerTheme"
      class="top-navigation"
      :shareMessage="shareMessage"
      :enableShare="header.enableShare"
      :enableClose="!header.hideClose"
      :jumpUrl="back"
      v-if="showHeader && !header.hideHeader"
    >
      <template v-show="header.title" slot="title">{{ header.title }}</template>
    </global-header>

    <div :class="cls" :style="containStyle">
      <transition :name="run" mode="out-in">
        <keep-alive v-if="hasCache" :exclude="keepExclude">
          <router-view/>
        </keep-alive>
        <slot v-else/>
      </transition>
    </div>

    <div class="bottom-navigation" v-show="!header.hideFooter">
      <span @click="$router.back()" class="icon icon-back" :class="{ disabled: !current }"/>
      <span
        @click="$router.forward()"
        class="icon icon-next"
        :class="{ disabled: current === routes.length - 1 }"
      />
    </div>
  </div>

  <div v-else :class="cls" :style="containStyle">
    <transition :name="run" mode="out-in">
      <keep-alive v-if="hasCache" :exclude="keepExclude">
        <router-view/>
      </keep-alive>
      <slot v-else/>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'
import { getUserAgent } from '../../utils/nativeInfo'
import GlobalHeader from '../GlobalHeader'
import './bar.scss'

const ROUTES = 'APP_ROUTES'

const getKeys = (name) => {
  const { search } = location
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = search.slice(1).match(reg)
  if (r != null) return unescape(decodeURI(r[2])); return null
}

const setHtmlClass = (cls, bool = true) => {
  document.documentElement.classList[bool ? 'add' : 'remove'](cls)
}

export default {
  props: {
    size: { // 组件大小
      type: String,
    },
    showHeader: { // 是否显示导航栏
      type: Boolean,
      default: true,
    },
    shareMessage: { // 分享内容
      type: Object
    },
    headerTheme: { //  主题
      type: String,
      default: 'light',
    },
    hasCache: { // 是否存在缓存
      type: Boolean,
      default: false
    },
    keepInclude: { // 只有匹配的组件会被缓存，hasCache为true时有效
      type: String | Array | RegExp
    },
    keepExclude: { // 任何匹配的组件都不会被缓存，hasCache为true时有效
      type: String | Array | RegExp
    }
  },
  components: {
    GlobalHeader
  },
  data() {
    return {
      cls: '', // 主题样式
      header: {}, // route.meta
      routes: [], // 路由数组
      current: 0, // 路由所在位置
      run: 'left', // 页面切换动画，前进 left 后退 right
      containStyle: {}, // 内容样式
      isBack: false, // 是否是回退
    }
  },
  computed: {
    dkshare() {
      return !this.$route.query.dkshare && !getKeys('dkshare')
    }
  },
  mounted() {
    const search = window.location.search.slice(1)
    const theme = qs.parse(search).theme || this.headerTheme
    const bool = theme === 'light' || theme === 'dark'
    this.cls = `container ${bool ? theme : 'light'}`
    setHtmlClass(bool ? theme : 'light')

    const { meta, query } = this.$route
    const _key = (window.history.state || {}).key || 0
    this.routes = JSON.parse(sessionStorage[ROUTES] || JSON.stringify([_key]))
    this.current = this.routes.reduce((tmp, v, i) => (v === _key ? i : tmp), 0)
    this.header = meta
    const { name, title } = this.header
    if (name) {
      this.header.title = query[name]
    } else if (i18n) {
      this.header.title = i18n.t(title)
    }
    setTimeout(() => {
      if (i18n && i18n.t(title) !== this.header.title) {
        this.header.title = i18n.t(title)
      }
    }, 500)

    this.calcHeight()
    window.addEventListener('resize', () => {
      this.calcHeight()
    })

    if (getUserAgent().service === 'IOS') {
      setHtmlClass('iPhone')
    }
  },
  methods: {
    calcHeight() {
      const { meta, query } = this.$route

      if (this.dkshare && this.showHeader && !meta.hideHeader) {
        setHtmlClass(this.headerTheme === 'light' ? 'hasDarkHeader' : 'hasWhiteHeader')
      } else {
        setHtmlClass('hasDarkHeader', false)
        setHtmlClass('hasWhiteHeader', false)
      }
      const name = window.location.pathname.slice(1).replace('.html', '')
      setHtmlClass('help', name === 'help-center')

      const height = document.querySelector('body > div').clientHeight
      const topH = this.showHeader && !this.header.hideHeader && this.dkshare ?
        (this.size === 'small' ? 1.06667 : 1.6) : 0
      const bottomH = !this.dkshare || this.header.hideFooter ? 0 : 1.35
      this.containStyle = {
        height: `calc(${height}px - ${topH + bottomH}rem)`
      }
    },
    back() {
      if (!this.current) {
        // 如果为首页则关闭页面
        window.location.href = 'obj-c::closeWindows'
      } else {
        // 如果不为首页则回退到首页
        this.isBack = true
        this.$router.go(-this.current)
      }
    }
  },
  watch: {
    $route(to, from) {
      this.header = to.meta
      const { name, title } = to.meta
      // 导航条标题 = query[meta.name]
      if (name) {
        this.header.title = to.query[name]
      } else if (i18n) {
        this.header.title = i18n.t(title)
      }
      this.run = 'left' // 页面切换动画
      const _key = (this.isBack ? this.routes[0] : (window.history.state || {}).key) || 0 // 页面唯一值
      this.isBack = false
      const cur = this.routes.reduce((tmp, v, i) => (v === _key ? i : tmp), 0)
      if (!cur && this.routes[0] !== _key) {
        // 跳转
        this.current += 1
        this.routes = [
          ...this.routes.slice(0, this.current),
          _key
        ]
        sessionStorage[ROUTES] = JSON.stringify(this.routes)
      } else if (cur < this.current) {
        // 回退
        this.run = 'right'
        this.current = cur
      } else {
        // 前进/replace
        this.current = cur
      }
      document.title = this.header.title
    },
    header({ hideHeader, hideFooter }, oValue) {
      if (hideHeader !== oValue.hideHeader || hideFooter !== oValue.hideFooter) {
        this.calcHeight()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RouteBar/RouteBar.vue